<template>
  <div class="w-container">
    <div class="top-title">
      <span v-if="!isCompare"
        >{{ topTitle }}-{{ selectModel.turbineType }}</span
      >
      <span v-else>对比</span>
    </div>
    <!--机组数据和成本参数-->
    <div
      class="show-model-data"
      v-if="menuRightType === 1 || menuRightType === 2"
    >
      <el-table
        :data="tableData"
        style="width: 100%;padding-bottom: 36px"
        size="mini"
        :height="tableHeight"
        border
        v-loading="tableLoading"
        :key="menuRightType === 1 ? 20 : 21"
        v-if="!isCompare"
        :span-method="spanMethod"
        :row-class-name="tableRowClassName"
      >
        <el-table-column
          type="index"
          label="序号"
          width="80"
          align="center"
          v-if="menuRightType !== 1"
        >
        </el-table-column>
        <el-table-column
          prop="serial"
          label="序号"
          width="80"
          align="center"
          v-else
        >
        </el-table-column>
        <el-table-column
          prop="quota"
          label="部件"
          width="200"
          align="center"
          v-if="menuRightType === 1"
        >
        </el-table-column>
        <el-table-column
          prop="quota"
          label="部套"
          width="230"
          align="center"
          v-else
        >
        </el-table-column>
        <el-table-column prop="unit" label="单位" width="120" align="center">
        </el-table-column>
        <el-table-column label="数值" align="center" v-if="menuRightType === 1">
          <template slot-scope="scope">
            <span
              v-if="scope.row.quota === '轮毂高度'"
              class="icon-span"
              style="white-space:nowrap"
            >
              <span>{{ scope.row.value }}</span>
              <span @click="wheelClick(scope.row.id)" title="查询轮毂详情">
                <img :src="detailCurveUrl" height="20px" color="red" />
              </span>
            </span>
            <span v-else>{{ scope.row.value }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="价格"
          align="center"
          prop="value"
          v-else
        ></el-table-column>
      </el-table>

      <el-table
        :data="tableDatas"
        style="width: 100%;"
        size="mini"
        :height="tableHeight"
        border
        :key="menuRightType === 1 ? 22 : 23"
        v-loading="tableCompareLoading"
        v-else
        :span-method="spanMethod"
        :row-class-name="tableRowClassName"
        class="jizutable"
      >
        <el-table-column
          type="index"
          label="序号"
          width="80"
          align="center"
          v-if="menuRightType !== 1"
        >
        </el-table-column>
        <el-table-column
          prop="serial"
          label="序号"
          width="80"
          align="center"
          v-else
        >
        </el-table-column>
        <el-table-column
          prop="quota"
          label="部件"
          width="230"
          align="center"
          v-if="menuRightType === 1"
        >
        </el-table-column>
        <el-table-column
          prop="quota"
          label="部套"
          width="230"
          align="center"
          v-else
        >
        </el-table-column>
        <el-table-column prop="unit" label="单位" width="100" align="center">
        </el-table-column>
        <el-table-column
          align="center"
          v-for="(item, index) in columns"
          :key="index"
          :label="item.label"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.quota === '轮毂高度'">
              <span>{{ scope.row[item.prop] }}</span>
              <span
                style="padding-left: 20px;font-size: 16px;cursor: pointer;"
                @click="wheelClick(item.id)"
              >
                <img :src="detailCurveUrl" height="20px" />
                <!--<i class="el-icon-picture-outline"></i>-->
              </span>
            </span>
            <span v-else>{{ scope.row[item.prop] }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!--机组数据和成本参数-->

    <!--装配数据-->
    <div v-if="menuRightType === 3">
      <el-table
        :data="tableData"
        style="width: 100%"
        size="mini"
        border
        key="3"
        v-if="!isCompare"
        v-loading="tableLoading"
        :span-method="assemblyObjectMethod"
        :header-cell-class-name="tableRowClassName1"
      >
        <el-table-column prop="number" label="序号" width="50" align="center">
        </el-table-column>
        <!-- <el-table-column prop="quota" label="指标" width="180" align="center">
        </el-table-column> -->
        <el-table-column label="装配数据" align="center">
          <el-table-column prop="quotas" width="180" align="center">
          </el-table-column>
          <el-table-column prop="quota" width="180" align="center">
          </el-table-column>
        </el-table-column>
        <el-table-column prop="unit" label="单位" width="180" align="center">
        </el-table-column>
        <el-table-column prop="value" label="数值" align="center">
        </el-table-column>
        <!-- <el-table-column
          prop="value"
          label="重量（kg）"
          width="180"
          align="center"
        >
        </el-table-column> -->
        <!-- <el-table-column label="尺寸（m）" align="center" prop="size">
          <el-table-column label="长" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.size.length }}</span>
            </template>
          </el-table-column>
          <el-table-column label="宽" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.size.wide }}</span>
            </template>
          </el-table-column>
          <el-table-column label="高" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.size.high }}</span>
            </template>
          </el-table-column>
          <el-table-column label="最大弦长" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.quota === '叶片（单支）'">{{
                scope.row.size.bladeMaxChordLength
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="叶根圆柱段外径" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.quota === '叶片（单支）'">{{
                scope.row.size.bladeCylinderDiameter
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="叶尖预弯" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.quota === '叶片（单支）'">{{
                scope.row.size.bladeTipPrebending
              }}</span>
            </template>
          </el-table-column>
        </el-table-column> -->
      </el-table>

      <!--机组装配数据对比-->
      <el-table
        :data="tableDatas"
        style="width: 100%"
        size="mini"
        border
        key="4"
        v-else
        :height="tableHeight - 4"
        v-loading="tableCompareLoading"
        :span-method="assemblyObjectMethod"
        :header-cell-class-name="tableRowClassName1"
      >
        <el-table-column prop="number" label="序号" width="50" align="center">
        </el-table-column>
        <el-table-column label="装配数据" align="center">
          <el-table-column prop="quotas" width="180" align="center">
          </el-table-column>
          <el-table-column prop="quota" width="180" align="center">
          </el-table-column>
        </el-table-column>
        <el-table-column prop="unit" label="单位" width="180" align="center">
        </el-table-column>
        <el-table-column
          v-for="(item, index) in assemblyColumns"
          :prop="item.prop"
          :key="index"
          :label="item.label"
          align="center"
        >
        </el-table-column>
        <!-- <el-table-column prop="quota" label="指标" width="150" align="center">
        </el-table-column> -->
        <!-- <el-table-column
          v-for="(item, index) in columns"
          :key="index"
          :label="item.label"
          align="center"
        >
          <el-table-column
            :prop="item.prop"
            label="重量（kg）"
            width="100"
            align="center"
          >
          </el-table-column>
          <el-table-column
            label="尺寸（m）"
            align="center"
            :prop="item.sizeProp"
          >
            <el-table-column label="长" align="center">
              <template slot-scope="scope">
                <span>{{
                  scope.row[item.sizeProp]
                    ? scope.row[item.sizeProp].length
                    : ''
                }}</span>
              </template>
            </el-table-column>
            <el-table-column label="宽" align="center">
              <template slot-scope="scope">
                <span>{{
                  scope.row[item.sizeProp] ? scope.row[item.sizeProp].wide : ''
                }}</span>
              </template>
            </el-table-column>
            <el-table-column label="高" align="center">
              <template slot-scope="scope">
                <span>{{
                  scope.row[item.sizeProp] ? scope.row[item.sizeProp].high : ''
                }}</span>
              </template>
            </el-table-column>
            <el-table-column label="最大弦长" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.quota === '叶片（单支）'">{{
                  scope.row[item.sizeProp]
                    ? scope.row[item.sizeProp].bladeMaxChordLength
                    : ''
                }}</span>
              </template>
            </el-table-column>
            <el-table-column label="叶根圆柱段外径" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.quota === '叶片（单支）'">{{
                  scope.row[item.sizeProp]
                    ? scope.row[item.sizeProp].bladeCylinderDiameter
                    : ''
                }}</span>
              </template>
            </el-table-column>
            <el-table-column label="叶尖预弯" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.quota === '叶片（单支）'">{{
                  scope.row[item.sizeProp]
                    ? scope.row[item.sizeProp].bladeTipPrebending
                    : ''
                }}</span>
              </template>
            </el-table-column>
          </el-table-column>
        </el-table-column> -->
      </el-table>
    </div>
    <!--装配数据-->

    <!--电气效率-->
    <div v-if="menuRightType === 4">
      <el-table
        :data="tableData"
        style="width: 100%;"
        size="mini"
        border
        key="5"
        v-if="!isCompare"
        v-loading="tableLoading"
        :span-method="arraySpanMethod"
      >
        <el-table-column type="index" label="序号" width="50" align="center">
        </el-table-column>
        <el-table-column prop="loadRate" label="负载率(%)" align="center">
        </el-table-column>
        <el-table-column
          prop="generatorEfficiency"
          label="发电机效率(%)"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="inverterEfficiency"
          label="变流器效率(%)"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="electricalEfficiency"
          label="电气系统效率(%)"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="auxiliaryCapacity"
          label="额定辅电容量（kW）"
          align="center"
        >
        </el-table-column>
      </el-table>

      <el-table
        :data="tableDatas"
        style="width: 100%"
        size="mini"
        border
        key="6"
        v-else
        v-loading="tableCompareLoading"
        :span-method="arraySpanMethods"
        class="dianqiTable"
      >
        <el-table-column type="index" label="序号" width="50" align="center">
        </el-table-column>
        <el-table-column prop="loadRate" label="负载率(%)" align="center">
        </el-table-column>
        <el-table-column
          v-for="(item, index) in columns"
          :key="index"
          :label="item.label"
          :prop="item.typeProp"
          align="center"
        >
          <el-table-column label="发电机效率(%)" align="center">
            <template slot-scope="scope">
              <span>{{
                scope.row[item.typeProp]
                  ? scope.row[item.typeProp].generatorEfficiency
                  : ''
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="变流器效率(%)" align="center">
            <template slot-scope="scope">
              <span>{{
                scope.row[item.typeProp]
                  ? scope.row[item.typeProp].inverterEfficiency
                  : ''
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="电气系统效率(%)" align="center">
            <template slot-scope="scope">
              <span>{{
                scope.row[item.typeProp]
                  ? scope.row[item.typeProp].electricalEfficiency
                  : ''
              }}</span>
            </template>
          </el-table-column>
          <!--          <el-table-column label="辅电容量（kW）" align="center">-->
          <!--          </el-table-column>-->
        </el-table-column>
      </el-table>

      <div
        v-loading="tableLoading"
        element-loading-text="加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
        class="res-chart"
        v-if="Object.keys(efficiencyEchartsdata).length > 0 && !isCompare"
      >
        <echart
          :option="mainOptions"
          :notMerge="true"
          :divStyle="{ height: '400px', width: '99%' }"
        ></echart>
      </div>
      <div
        v-loading="tableLoading"
        element-loading-text="加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
        class="res-chart"
        v-if="compareEfficiencyData.length > 0 && isCompare"
      >
        <echart
          :option="mainsOptions"
          :notMerge="true"
          :divStyle="{ height: '400px', width: '99%' }"
        ></echart>
      </div>
      <!-- <div class="tube-detail">
        <div>额定辅电容量/kW：65.00</div>
        <div>辅电占比：辅电容量÷机组额定功率</div>
        <div>电气系统效率：发电机额定效率×变流器额定效率×辅电占比</div>
      </div> -->
    </div>
    <!--电气效率-->

    <!--TODO 弹出轮毂高度表-->
    <el-dialog
      v-drag:common
      title="机组塔筒数据"
      :visible.sync="wheelDialog.visible"
      width="80%"
      @cancel="cancelDialog"
    >
      <div class="show-model-data">
        <el-table
          :data="wheelInfo"
          style="width: 100%;padding-bottom: 70px;"
          height="400px"
          size="mini"
          border
          key="7"
          ref="wheelTable"
          v-loading="wheelDialog.wheelLoading"
          :span-method="wheelArraySpanMethod"
          :header-cell-class-name="tableRowClassName1"
          class="turbine-table"
        >
          <el-table-column width="50" label="序号" prop="serial" align="center">
          </el-table-column>
          <el-table-column label="项目" align="center">
            <el-table-column prop="term" label="项目" align="center">
            </el-table-column>
            <el-table-column prop="name" align="center"> </el-table-column>
          </el-table-column>
          <el-table-column prop="unit" label="单位" align="center">
          </el-table-column>
          <!-- <el-table-column
            align="center"
            v-for="(item, index) in turbineHubDetails"
            :key="index"
            :label="item.turbineHub.toString()"
            prop="turbineHubDetails"
          >
          </el-table-column>-->
          <el-table-column
            prop="value"
            label="数值"
            align="center"
          ></el-table-column>
        </el-table>
      </div>
    </el-dialog>
    <!--弹出轮毂高度表-->
  </div>
</template>

<script>
import {
  filterChartsData,
  filterCompareTable,
  filterTableData
} from '../helper/filter';
import { mapState } from 'vuex';
import { MENU_RIGHT } from '../helper/menuright';
import isEmpty from 'lodash/isEmpty';

export default {
  props: {},
  data() {
    return {
      tableLoading: false,
      tableCompareLoading: false,
      // 对比时候的ID数组
      idList: [],
      // 当前选中
      id: '',
      turbineLists: [],
      wheelDialog: {
        visible: false,
        wheelLoading: false
      },
      wheelInfo: [],
      turbineHubDetails: [],
      // 电气效率
      efficiencyEchartsdata: {},
      topTitle: '',
      tableData: [],
      tableDatas: [],
      tableList: [],
      menuList: MENU_RIGHT,
      // 当前选中的机组
      selectModel: {},
      // 额定辅电容量
      auxiliaryCapacity: '',
      auxiliaryCapacitys: [],
      // 对比电气效率数据
      compareEfficiencyData: [],
      // 电气效率图表配置
      mainOptions: null,
      // 对比的电气效率echart
      mainsOptions: null,
      detailCurveUrl: require('@/asset/public-database/detail.png'),
      fullHeight: document.documentElement.clientHeight,
      tableHeight: 0,
      color: [
        '#F44336',
        '#9C27B0',
        '#3F51B5',
        '#00BCD4',
        '#009688',
        '#8BC34A',
        '#FF9800',
        '#607D8B',
        '#9E9E9E',
        '#795548',
        '#673AB7',
        '#03A9F4'
      ]
    };
  },
  computed: {
    ...mapState('model', [
      'checkedList',
      'menuRightType',
      'isCompare',
      'modelList',
      'currentModel'
    ]),
    // tableHeight() {
    //   return window.innerHeight - 95;
    // },
    assemblyColumns() {
      if (isEmpty(this.tableList)) return [];
      const cols = [];
      this.tableList.forEach((item, i) => {
        cols.push({
          prop: `value${i === 0 ? '' : i}`,
          label: item.typeName
        });
      });
      return cols;
    },
    columns() {
      if (isEmpty(this.tableList)) return [];
      const cols = [];
      this.tableList.forEach((eco, i) => {
        if (this.menuRightType === 4) {
          cols.push({
            label: eco.typeName || eco[0].typeName,
            typeProp: `modelType${i === 0 ? '' : i}`
          });
          return;
        }
        if (this.menuRightType === 3) {
          cols.push({
            label: eco.typeName,
            prop: `value${i === 0 ? '' : i}`,
            sizeProp: `size${i === 0 ? '' : i}`
          });
          return;
        }
        cols.push({
          label: eco.typeName,
          prop: `value${i === 0 ? '' : i}`,
          id: eco.turbineTypeId
        });
      });
      return cols;
    }
  },
  watch: {
    // 表格高度随滚动条变化而变化
    fullHeight() {
      if (this.tableData.length > 0) {
        this.calcBoxHeight();
      }
    },
    // 当前选中的机组
    currentModel(val) {
      if (typeof val === 'object' && Object.keys(val).length <= 0) {
        this.tableData = [];
        this.selectModel = {};
        return;
      }
      this.selectModel = val;
      this.id = val.turbineTypeId;
      if (!this.isCompare) {
        this.fetchModel();
      }
    },
    checkedList(val) {
      if (val.length === 0) {
        return;
      }
      this.idList = val;
      if (this.isCompare) {
        this.fetchCompareModel();
      }
    },
    menuRightType(val) {
      this.menuList.forEach(item => {
        if (item.type === val) {
          this.topTitle = item.name;
        }
      });
      if (this.isCompare) {
        this.fetchCompareModel();
      } else {
        this.fetchModel();
      }
    },
    isCompare(val) {
      if (val) {
        this.fetchCompareModel();
      } else {
        this.fetchModel();
      }
    }
  },
  methods: {
    tableRowClassName1({ row }) {
      if (row.length === 2) {
        return 'dis';
      }
    },
    tableRowClassName({ row }) {
      let reg = /^[0-9]*[1-9][0-9]*$/;
      if (reg.test(row.serial) && Number(row.serial) <= 20) {
        return 'tex_l';
      }
    },
    // 获取机组详情数据
    async fetchModel() {
      this.tableData = [];
      this.efficiencyEchartsdata = {};
      this.tableLoading = true;
      await this.$fetch('/windfarm/turbineType/getTurbine', {
        params: {
          turbineTypeId: this.id,
          type: this.menuRightType
        }
      }).then(res => {
        if (res.code === 0) {
          if (!res.data.turbine) {
            this.tableLoading = false;
            this.efficiencyEchartsdata = {};
            // 成本参数无数据默认表格高度
            this.tableHeight = 96;
            return;
          }
          // if (this.menuRightType === 1) {
          //   this.auxiliaryCapacity = res.data.auxiliaryCapacity;
          // }
          this.tableData = filterTableData(
            res.data.turbine,
            this.menuRightType
          );
          // 电气效率图表
          if (this.menuRightType === 4) {
            this.auxiliaryCapacity = res.data.auxiliaryCapacity;
            this.tableData = this.tableData.map(item => {
              item.auxiliaryCapacity = this.auxiliaryCapacity;
              return item;
            });
            this.efficiencyEchartsdata = filterChartsData(res.data.turbine);
            this.$nextTick(() => {
              this.efficiencyEchartsInit(this.efficiencyEchartsdata);
            });
          }
          this.calcBoxHeight();
          this.tableLoading = false;
        } else {
          this.tableLoading = false;
        }
      });
    },
    // 获取对比机组详情数据
    async fetchCompareModel() {
      this.tableDatas = [];
      this.tableList = [];
      this.tableCompareLoading = true;
      await this.$fetch('/windfarm/turbineType/getTurbines', {
        params: {
          turbineTypeIds: this.idList.join(','),
          type: this.menuRightType
        }
      })
        .then(res => {
          if (res.code === 0) {
            if (!res.data.turbineList) {
              this.tableDatas = [];
              this.compareEfficiencyData = [];
              this.tableList = [];
              // 成本参数无数据默认表格高度
              this.tableHeight = 95;
              this.tableList = this.modelList.map(lis => {
                let item = {};
                item.typeName = lis['name'];
                item.turbineTypeId === lis.id;
                return item;
              });
              this.tableCompareLoading = false;
              return;
            }
            this.calcBoxHeight();
            if (this.menuRightType === 1) {
              res.data.turbineList.forEach(item => {
                this.auxiliaryCapacitys.push({
                  id: item.turbineTypeId,
                  auxiliaryCapacity: item.auxiliaryCapacity
                });
              });
            }
            if (this.menuRightType === 4) {
              this.tableDatas = filterCompareTable(
                this.filterEfficiencyData(
                  res.data.turbineList,
                  'turbineTypeId'
                ),
                this.menuRightType,
                this.modelList
              );
              // this.tableDatas = this.tableDatas.map(item => {
              //   this.auxiliaryCapacitys.forEach((val, i) => {
              //     item[`modelType${i === 0 ? '' : i}`]['auxiliaryCapacity'] =
              //       val.auxiliaryCapacity;
              //   });
              //   return item;
              // });
              let filterData = this.filterEfficiencyData(
                res.data.turbineList,
                'turbineTypeId'
              );
              this.compareEfficiencyData = filterData.map(arr => {
                this.modelList.forEach(item => {
                  if (arr[0].turbineTypeId === item.id) {
                    arr = arr.map(val => {
                      val.typeName = item.name;
                      return val;
                    });
                  }
                });
                return arr;
              });
              // this.tableList = filterData.map(item => {
              //   item = item.map(val => {
              //     if (!val.typeName) {
              //       this.modelList.forEach(lis => {
              //         if (val.turbineTypeId === lis.id) {
              //           val.typeName = lis['name'];
              //         }
              //       });
              //     }
              //     return val;
              //   });
              //   return item;
              // });
              this.tableList = this.modelList.map(lis => {
                let item = {};
                item.typeName = lis['name'];
                item.turbineTypeId === lis.id;
                return item;
              });
              this.$nextTick(() => {
                this.compareEfficiency(this.compareEfficiencyData);
              });
              this.tableCompareLoading = false;
              return;
            }
            // 非电气效率页面
            this.tableDatas = filterCompareTable(
              res.data.turbineList,
              this.menuRightType,
              this.modelList
            );
            // this.tableList = res.data.turbineList.map(item => {
            //   if (!item.typeName) {
            //     this.modelList.forEach(lis => {
            //       if (item.turbineTypeId === lis.id) {
            //         item.typeName = lis['name'];
            //       }
            //     });
            //   }
            //   return item;
            // });
            this.tableList = this.modelList.map(lis => {
              let item = {};
              item.typeName = lis['name'];
              item.turbineTypeId = lis.id;
              return item;
            });
            this.tableCompareLoading = false;
          } else {
            this.tableCompareLoading = false;
          }
        })
        .catch(e => {
          this.tableCompareLoading = false;
          throw e;
        });
    },
    filterEfficiencyData(arr, str) {
      let newArr = [];
      let dataArr = [];
      let temp;
      // arr = arr.sort(function(a, b) {
      //   let s = a[str];
      //   let t = b[str];
      //   return s < t ? -1 : 1;
      // });

      if (arr.length) {
        temp = arr[0][str];
      }
      for (let i = 0; i < arr.length; i++) {
        if (arr[i][str] === temp) {
          dataArr.push(arr[i]);
        } else {
          temp = arr[i][str];
          newArr.push(dataArr);
          dataArr = [arr[i]];
        }
      }
      newArr.push(dataArr);
      return newArr;
    },
    // 渲染机组电气效率图表
    efficiencyEchartsInit(obj) {
      this.mainOptions = {
        color: ['#F44336', '#9C27B0', '#3F51B5'],
        xAxis: {
          name: '负载率(%)',
          type: 'category',
          data: obj.loadRate,
          boundaryGap: false,
          axisLine: {
            lineStyle: {
              type: 'solid',
              color: '#fff' //左边线的颜色
            }
          },
          axisLabel: {
            textStyle: {
              color: '#fff' //坐标值得具体的颜色
            }
          },
          splitLine: {
            show: true,
            lineStyle: {
              type: 'dashed'
            }
          }
        },
        tooltip: {
          trigger: 'axis',
          formatter: function(params) {
            let res = '<span>负载率:' + params[0].name + '%</span>';
            for (var i = 0; i < params.length; i++) {
              res +=
                '<p>' + params[i].seriesName + ':' + params[i].data + '%</p>';
            }
            return res;
          }
        },
        backgroundColor: '#3b3a39',
        toolbox: {},
        legend: {
          data: ['发电机效率', '变流器效率', '电气系统效率'],
          textStyle: {
            color: '#fff'
          }
        },
        grid: {
          left: '3%',
          right: '8%',
          bottom: '3%',
          containLabel: true
        },
        yAxis: {
          type: 'value',
          name: '效率(%)',
          axisLine: {
            lineStyle: {
              type: 'solid',
              color: '#fff'
            }
          },
          splitLine: {
            show: true,
            lineStyle: {
              type: 'dashed'
            }
          },
          axisLabel: {
            textStyle: {
              color: '#fff'
            }
          },
          min: function(value) {
            return Math.floor(value.min / 10) * 10;
          },
          max: function() {
            return 100;
          }
        },

        series: [
          {
            name: '发电机效率',
            type: 'line',
            // itemStyle: {
            //   normal: {
            //     lineStyle: {
            //       color: '#00edfc'
            //     }
            //   }
            // },
            data: obj.generatorEfficiency
          },
          {
            name: '变流器效率',
            type: 'line',
            // itemStyle: {
            //   normal: {
            //     lineStyle: {
            //       color: '#ffba00'
            //     }
            //   }
            // },
            data: obj.inverterEfficiency
          },
          {
            name: '电气系统效率',
            type: 'line',
            // itemStyle: {
            //   normal: {
            //     lineStyle: {
            //       color: '#dde00c'
            //     }
            //   }
            // },
            data: obj.electricalEfficiency
          }
        ]
      };
    },
    // 渲染对比机组电气效率图表
    compareEfficiency(data) {
      let str1 = '发电机效率';
      let str2 = '变流器效率';
      let str3 = '电气系统效率';
      let legends = [];
      let dataSeries = [];
      data.forEach(item => {
        let arr1 = [];
        let arr2 = [];
        let arr3 = [];
        let obj1 = {};
        let obj2 = {};
        let obj3 = {};
        legends.push(`${item[0].typeName}-${str1}`);
        legends.push(`${item[0].typeName}-${str2}`);
        legends.push(`${item[0].typeName}-${str3}`);
        arr1 = item.map(val => {
          return [val.loadRate, val.generatorEfficiency];
        });
        obj1.data = arr1;
        obj1.name = `${item[0].typeName}-${str1}`;
        obj1.type = 'line';
        // obj1.itemStyle = {
        //   normal: {
        //     color: '#00edfc',
        //     lineStyle: {
        //       color: '#00edfc'
        //     }
        //   }
        // };
        dataSeries.push(obj1);
        arr2 = item.map(val => {
          return [val.loadRate, val.inverterEfficiency];
        });
        // obj2.itemStyle = {
        //   normal: {
        //     color: '#ffba00',
        //     lineStyle: {
        //       color: '#ffba00'
        //     }
        //   }
        // };
        obj2.type = 'line';
        obj2.name = `${item[0].typeName}-${str2}`;
        obj2.data = arr2;
        dataSeries.push(obj2);

        arr3 = item.map(val => {
          return [val.loadRate, val.electricalEfficiency];
        });
        // obj3.itemStyle = {
        //   normal: {
        //     color: '#ffba00',
        //     lineStyle: {
        //       color: '#ffba00'
        //     }
        //   }
        // };
        obj3.type = 'line';
        obj3.name = `${item[0].typeName}-${str3}`;
        obj3.data = arr3;
        dataSeries.push(obj3);
      });
      this.mainsOptions = {
        color: [
          '#F44336',
          '#9C27B0',
          '#3F51B5',
          '#00BCD4',
          '#009688',
          '#8BC34A',
          '#FF9800',
          '#607D8B',
          '#09E9E9E',
          '#795548',
          '#673AB7',
          '#03A9F4'
        ],
        xAxis: {
          name: '负载率(%)',
          type: 'value',
          //splitNumber: 10,
          min: 0,
          max: 100,
          axisLine: {
            lineStyle: {
              type: 'solid',
              color: '#fff' //左边线的颜色
            }
          },
          boundaryGap: false,
          axisLabel: {
            textStyle: {
              color: '#fff' //坐标值得具体的颜色
            }
          },
          splitLine: {
            show: true,
            lineStyle: {
              type: 'dashed'
            }
          }
        },
        tooltip: {
          trigger: 'axis',
          formatter: function(params) {
            let res = '<p>负载率:' + params[0].axisValue + '%</p>';
            for (var i = 0; i < params.length; i++) {
              res +=
                '<p>' +
                params[i].seriesName +
                ':' +
                params[i].data[1] +
                '%</p>';
            }
            return res;
          }
        },
        backgroundColor: '#3b3a39',
        toolbox: {},
        grid: {
          left: '3%',
          right: '10%',
          bottom: '3%',
          top: '25%',
          containLabel: true
        },
        yAxis: {
          type: 'value',
          name: '效率(%)',
          axisLine: {
            lineStyle: {
              type: 'solid',
              color: '#fff'
            }
          },
          splitLine: {
            show: true,
            lineStyle: {
              type: 'dashed'
            }
          },
          axisLabel: {
            textStyle: {
              color: '#fff'
            }
          },
          min: function(value) {
            return Math.floor(value.min / 10) * 10;
          },
          max: function() {
            return 100;
          }
        },
        legend: {
          data: legends,
          textStyle: {
            color: '#fff'
          }
        },

        series: dataSeries
      };
    },
    // 获取轮毂高度详情
    async fetchWheel(id) {
      this.wheelInfo = [];
      this.wheelDialog.wheelLoading = true;
      await this.$fetch('/windfarm/turbineType/getTurbineHubDetails', {
        params: {
          turbineTypeId: id
        }
      })
        .then(res => {
          if (res.code === 0) {
            if (!res.data.turbineHubDetails) {
              this.wheelDialog.wheelLoading = false;
              return;
            }
            let wheelData = res.data.turbineHubDetails;
            let info1 = {
              term: '轮毂高度（m）',
              serial: 1,
              unit: '',
              name: ''
            };
            wheelData.forEach((item, i) => {
              info1[`value${i === 0 ? '' : i}`] = wheelData[i].turbineHub;
            });
            this.wheelInfo.push(info1);

            for (let j = 0; j < 10; j++) {
              let rowDetail = {};
              // let name = tubeDetail[key];
              let unit = 'm';
              rowDetail = { unit, serial: j + 2 };
              rowDetail.term = `塔筒${j + 1}段`;
              rowDetail.name = '长度';
              wheelData.forEach((item, i) => {
                rowDetail[`value${i === 0 ? '' : i}`] =
                  item.turbineHubDetails[j]['length'];
              });
              this.wheelInfo.push(rowDetail);
              let rowDetail1 = {};
              let unit1 = 'kg';
              rowDetail1 = { unit: unit1 };
              rowDetail1.name = '宽度';
              // rowDetail1.term = `塔筒${j + 1}段`;
              wheelData.forEach((item, i) => {
                rowDetail1[`value${i === 0 ? '' : i}`] =
                  item.turbineHubDetails[j]['weight'];
              });
              this.wheelInfo.push(rowDetail1);
            }

            let info12 = { term: '附件重量', serial: 12, unit: '', name: '' };
            wheelData.forEach((item, i) => {
              info12[`value${i === 0 ? '' : i}`] =
                wheelData[i].weightAccessories;
            });
            this.wheelInfo.push(info12);

            let info13 = {
              term: '塔架总重量',
              serial: 13,
              unit: 'kg',
              name: ''
            };
            wheelData.forEach((item, i) => {
              info13[`value${i === 0 ? '' : i}`] = wheelData[i].towerAllWeight;
            });
            this.wheelInfo.push(info13);

            let info14 = {
              term: '基础环或锚栓组合件',
              serial: 14,
              unit: '',
              name: ''
            };
            wheelData.forEach((item, i) => {
              info14[`value${i === 0 ? '' : i}`] = wheelData[i].assembly;
            });
            this.wheelInfo.push(info14);

            let info15 = {
              term: '塔架总重量（含基础环或锚栓）',
              serial: 15,
              unit: 'kg',
              name: ''
            };
            wheelData.forEach((item, i) => {
              info15[`value${i === 0 ? '' : i}`] =
                wheelData[i].towerTotalWeight;
            });
            this.wheelInfo.push(info15);

            let info16 = {
              term: '钢材规格型号',
              serial: 16,
              unit: '',
              name: ''
            };
            wheelData.forEach((item, i) => {
              info16[`value${i === 0 ? '' : i}`] = wheelData[i].steelsType;
            });
            this.wheelInfo.push(info16);

            let info17 = {
              term: '基础钢筋用量',
              serial: 17,
              unit: 'kg',
              name: ''
            };
            wheelData.forEach((item, i) => {
              info17[`value${i === 0 ? '' : i}`] =
                wheelData[i].reinforcementAmount;
            });
            this.wheelInfo.push(info17);

            let info18 = {
              term: '基础钢筋型号',
              serial: 18,
              unit: '',
              name: ''
            };
            wheelData.forEach((item, i) => {
              info18[`value${i === 0 ? '' : i}`] =
                wheelData[i].reinforcementType;
            });
            this.wheelInfo.push(info18);

            let info19 = {
              term: '基础混凝土用量',
              serial: 19,
              unit: 'm³',
              name: ''
            };
            wheelData.forEach((item, i) => {
              info19[`value${i === 0 ? '' : i}`] = wheelData[i].concreteDosage;
            });
            this.wheelInfo.push(info19);

            this.turbineHubDetails = res.data.turbineHubDetails;
            this.wheelDialog.wheelLoading = false;
          } else {
            this.wheelDialog.wheelLoading = false;
          }
        })
        .catch(e => {
          this.wheelDialog.wheelLoading = false;
          throw e;
        });
    },
    wheelClick(id) {
      this.wheelInfo = [];
      this.wheelDialog.visible = true;
      this.fetchWheel(id);
    },
    cancelDialog() {
      this.wheelDialog.visible = false;
      this.wheelDialog.wheelLoading = false;
      this.wheelInfo = [];
    },
    arraySpanMethod({ column }) {
      if (column.property === 'auxiliaryCapacity') {
        return [10, 1];
      }
    },
    wheelArraySpanMethod({ row, columnIndex }) {
      if (columnIndex === 1) {
        if (
          row.serial === 2 ||
          row.serial === 3 ||
          row.serial === 4 ||
          row.serial === 5 ||
          row.serial === 6 ||
          row.serial === 7 ||
          row.serial === 8 ||
          row.serial === 9 ||
          row.serial === 10 ||
          row.serial === 11
        ) {
          return [2, 1];
        } else if (
          row.serial === 1 ||
          row.serial === 12 ||
          row.serial === 13 ||
          row.serial === 14 ||
          row.serial === 15 ||
          row.serial === 16 ||
          row.serial === 17 ||
          row.serial === 18 ||
          row.serial === 19
        ) {
          return [1, 2];
        } else {
          return [0, 0];
        }
      } else if (columnIndex === 0) {
        if (
          row.serial === 2 ||
          row.serial === 3 ||
          row.serial === 4 ||
          row.serial === 5 ||
          row.serial === 6 ||
          row.serial === 7 ||
          row.serial === 8 ||
          row.serial === 9 ||
          row.serial === 10 ||
          row.serial === 11
        ) {
          return [2, 1];
        } else if (
          row.serial === 1 ||
          row.serial === 12 ||
          row.serial === 13 ||
          row.serial === 14 ||
          row.serial === 15 ||
          row.serial === 16 ||
          row.serial === 17 ||
          row.serial === 18 ||
          row.serial === 19
        ) {
          return [1, 1];
        } else {
          return [0, 0];
        }
      } else if (columnIndex === 2) {
        if (
          row.serial === 2 ||
          row.serial === 3 ||
          row.serial === 4 ||
          row.serial === 5 ||
          row.serial === 6 ||
          row.serial === 7 ||
          row.serial === 8 ||
          row.serial === 9 ||
          row.serial === 10 ||
          row.serial === 11
        ) {
          return [1, 1];
        } else if (
          row.serial === 1 ||
          row.serial === 12 ||
          row.serial === 13 ||
          row.serial === 14 ||
          row.serial === 15 ||
          row.serial === 16 ||
          row.serial === 17 ||
          row.serial === 18 ||
          row.serial === 19
        ) {
          return [0, 0];
        }
      } else {
        return [1, 1];
      }
    },
    arraySpanMethods({ column }) {
      if (column.label === '辅电容量（kW）') {
        return [10, 1];
      }
    },
    spanMethod({ row, columnIndex }) {
      // if (columnIndex === 0) {
      //   if (row.serial === '4.10') {
      //     if (rowIndex === 46) {
      //       return [5, 1];
      //     } else {
      //       return [0, 0];
      //     }
      //   }
      // }
      let reg = /^[0-9]*[1-9][0-9]*$/;
      if (reg.test(row.serial) && Number(row.serial) <= 20) {
        if (columnIndex > 0) {
          if (!this.isCompare) {
            return [1, 3];
          } else {
            return [1, this.modelList.length + 2];
          }
        }
      }
    },
    // 机组装配table单元格合并方法
    assemblyObjectMethod({ row, columnIndex }) {
      if (columnIndex === 0) {
        if (row.quotas && row.quotas !== '叶片（单支）') {
          return [4, 1];
        } else {
          if (row.quotas === '叶片（单支）') {
            return [5, 1];
          } else {
            return [0, 0];
          }
        }
      } else if (columnIndex === 1) {
        if (row.quotas && row.quotas !== '叶片（单支）') {
          return [4, 1];
        } else {
          if (row.quotas === '叶片（单支）') {
            return [5, 1];
          } else {
            return [0, 0];
          }
        }
      }
    },
    calcBoxHeight() {
      let viewPortHeight = document.documentElement.clientHeight;
      let documentTop = document.documentElement.clientTop;
      this.tableHeight = viewPortHeight - 110 - documentTop;
    },
    getBodyHeight() {
      this.fullHeight = document.documentElement.clientHeight;
    }
  },
  mounted() {
    window.addEventListener('resize', this.getBodyHeight);
    this.menuList.forEach(item => {
      if (item.type === this.menuRightType) {
        this.topTitle = item.name;
      }
    });
    if (Object.keys(this.currentModel).length !== 0) {
      this.selectModel = this.currentModel;
      this.id = this.currentModel.turbineTypeId;
      this.fetchModel();
    }
  }
};
</script>

<style lang="less" scoped>
/deep/.dis {
  display: none !important;
}
///deep/.el-table__body-wrapper {
//  height: 100% !important;
//}
/deep/.el-table.el-table--mini {
  background-color: @bgColor;
}
/deep/.el-table__row.tex_l > td:not(:nth-child(2)) {
  padding: 0 !important;
  margin: 0 !important;
  width: 0;
  // padding-left: 50px;
  // text-align: left !important;
  /*font-weight: 500;*/
  /*font-size: 16px;*/
}
/deep/.el-table__row.tex_l > td:nth-child(2) {
  padding-left: 50px;
  text-align: left !important;
  /*font-weight: 500;*/
  /*font-size: 16px;*/
}
.w-container {
  width: 100%;
  max-height: 100%;
  // padding-bottom: 20px;
  .el-table {
    max-height: 100%;
  }

  .top-title {
    width: 100%;
    height: 26px;
    line-height: 26px;
    color: white;
    background-color: #003e8e;
    padding-left: 20px;
    box-sizing: border-box;
    font-size: 13px;
  }
  .res-chart {
    margin-top: 20px;
    height: 400px;
    padding-bottom: 20px;
    width: 90%;
  }
  .e-container {
    height: 100%;
    width: 100%;
  }
  .tube-detail {
    padding-bottom: 30px;
    padding-left: 20px;
    color: #fff;
    font-size: 12px;
    div:first-child {
      margin-top: 10px;
    }
  }
  /deep/.icon-span {
    box-sizing: border-box;
    position: relative;
    width: 100px;
    img {
      /*padding-left: 60px;*/
      /*margin-left: 60px;*/
      position: absolute;
      left: 40px;
      font-size: 25px;
      cursor: pointer;
      color: red;
      font-weight: bold;
    }
  }
}
</style>

<style lang="less" scoped>
/deep/.el-table thead.is-group th {
  background-color: #0477a1;
  color: #fff;
}
/deep/.el-table th {
  background-color: #0477a1;
  color: #fff;
}
/deep/.el-table tr:nth-of-type(odd) {
  background-color: #1e608f;
  color: #fff;
}
/deep/ .el-table tr:nth-of-type(even) {
  background-color: #126e6d;
  color: #fff;
}
/deep/.el-table--enable-row-hover .el-table__body tr:hover > td {
  background-color: #0477a1;
}
/deep/.el-table__body tr.current-row > td {
  background-color: #0477a1;
}
/deep/.el-table th.gutter {
  display: table-cell !important;
}
/deep/.el-table--border th.gutter:last-of-type {
  display: block !important;
  width: 12px;
  border: 0;
  padding: 0;
}
/deep/colgroup col[name='gutter'] {
  display: table-cell !important;
}
/deep/.dianqiTable.el-table--border th.gutter:last-of-type {
  display: none !important;
}
/deep/.jizutable.el-table--border th.gutter:last-of-type {
  display: table-cell !important;
  padding: 0 !important;
}
/deep/.turbine-table th.gutter:last-of-type {
  display: table-cell !important;
}
/deep/.turbine-table th.gutter {
  display: table-cell !important;
}
</style>
